import React from 'react'

const ButtonLoader = ({fontSize}) => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{height:'50%' , verticalAlign:"center", fontSize:fontSize}}>
  <div className="spinner-border" role="status" style={{fontSize:fontSize}}>
    <span className="sr-only">Loading...</span>
  </div>
</div>
  )
}

export default ButtonLoader
